import { render, staticRenderFns } from "./CloseTicket.vue?vue&type=template&id=8f6f3936"
import script from "./CloseTicket.js?vue&type=script&lang=js&external"
export * from "./CloseTicket.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports